// extracted by mini-css-extract-plugin
export default {"bodyContainer":"Home_bodyContainer__ximUB","routesContainer":"Home_routesContainer__ZDv03","footer":"Home_footer__PkRbp"};